// Remembers which console cards a person left open.
//
// The Season overview card carried a comment claiming it was "collapsible and
// remembered" while nothing in the application persisted anything: `data-track`
// is read only by campaignSequenceSticky, and only for sticky heads. So closing
// a card lasted until the next page load — which is most of the reason the
// overview felt like it took the whole screen no matter what you did with it.
//
// Keyed by PATHNAME as well as track: /admin/send_monitor and
// /admin/campaign_sequence both render `details[data-track]` cards, and several
// of them share a track name, so a track-only key would have one screen
// silently opening and closing the other's sections.

export const STORAGE_PREFIX = 'cs-card-open';

export function storageKey(track, path = window.location.pathname) {
  return `${STORAGE_PREFIX}:${path}:${track}`;
}

// Every access is guarded. localStorage throws outright in some private-browsing
// modes and when a browser has storage disabled, and a remembered disclosure
// state is never worth a page that dies on load — failing here just means "no
// memory", which is exactly today's behaviour.
function read(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage unavailable. The card still opens and closes; it just forgets.
  }
}

export function initCardMemory(root = document) {
  const cards = root.querySelectorAll('details[data-track]');

  if (!cards.length) return false;

  cards.forEach((card) => {
    const key = storageKey(card.dataset.track);
    const remembered = read(key);

    // Only override the template's default when there IS a memory. A card
    // nobody has touched keeps whatever the view decided, so changing a
    // default in the ERB still reaches everyone who has not expressed a
    // preference.
    if (remembered === 'open') card.open = true;
    if (remembered === 'closed') card.open = false;

    card.addEventListener('toggle', () => write(key, card.open ? 'open' : 'closed'));
  });

  return true;
}
